document.addEventListener('DOMContentLoaded', () => {
    handleSearchPopup();
    handleNewsletterPopup();
    handleCartPopup();
    handleMinicartProductRemove();
    hookAddToCartSuccess();
})

function handleSearchPopup() {
    const headerSearchPopup = document.querySelector('.header__search-popup');
    const headerSearchPopupTrigger = document.querySelector('.header__right__element.search a');
    const headerSearchPopupCloseTrigger = headerSearchPopup.querySelector('.header__search-popup__close-icon');

    const listener = (e) => {
        if (e.propertyName === 'transform') {
            if (headerSearchPopup.classList.contains('open')) {
                trapFocus(headerSearchPopup);
            } else {
                removeTrapFocus(headerSearchPopupTrigger);
            }
        }
    };

    headerSearchPopup.addEventListener('transitionend', listener);

    handleEscape(() => {
      if (headerSearchPopup.classList.contains('open')) {
        headerSearchPopupCloseTrigger.click();
        return true;
      } else {
        return false;
      }
    });
}

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )).filter(item => item.style.display !== 'none')
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function handleNewsletterPopup() {
    const newsletterPopup = document.getElementById('newsletter-popup');
    const newsletterPopupCloseTrigger = newsletterPopup.querySelector('.newsletter-popup__close-icon');
    let activeElement;

    const listener = (e) => {
        if (e.propertyName === 'transform') {
            if (newsletterPopup.classList.contains('timed-popup__visible')) {
                activeElement = document.activeElement;
                trapFocus(newsletterPopup);
            } else {
                removeTrapFocus(activeElement);
            }
        }
    };

    newsletterPopup.addEventListener('transitionend', listener);

    handleEscape(() => {
        if (newsletterPopup.classList.contains('timed-popup__visible')) {
            newsletterPopupCloseTrigger.click();
            return true;
        } else {
            return false;
        }
    });
}

function handleEscape(callback) {
    document.addEventListener('keyup', function (event) {
        const key = event.key;

        if (key === 'Escape' && callback()) {
            event.stopPropagation();
        }
    });
}

function handleCartPopup() {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartDrawerCloseTrigger = cartDrawer.querySelector('.js-drawer-close');
    let activeElement;

    const listener = (e) => {
        if (e.propertyName === 'transform') {
            if (cartDrawer.classList.contains('js-drawer-open')) {
                activeElement = document.activeElement;
                trapFocus(cartDrawer);
                document.documentElement.classList.add('no-scroll');
            } else {
                removeTrapFocus(activeElement);
                 document.documentElement.classList.remove('no-scroll');
            }
        }
    };

    cartDrawer.addEventListener('transitionend', listener);

    handleEscape(() => {
        if (cartDrawer.classList.contains('js-drawer-open')) {
            cartDrawerCloseTrigger?.click();
            return true;
        } else {
            return false;
        }
    });
}

function handleMinicartProductRemove() {
    document.addEventListener('click', (e) => {
        if (!!e.target.closest('.ajaxcart__qty-remove')) {
            const cartStatus = document.getElementById('minicart-live-region');
            const productName = e.target.closest('.ajaxcart__product')?.querySelector('.ajaxcart__product-name')?.textContent;
            if (cartStatus && productName) {
                cartStatus.innerHTML = `<span class="product-name">${productName}</span> ${window.translations.item_removed}`;
            }
        }
    });
}


function hookAddToCartSuccess() {
  window.addEventListener('AVADA:add', function (event) {
    const item = event.detail;
    if (!item) return;

    const cartStatus = document.getElementById('minicart-live-region');
    if (cartStatus) {
      cartStatus.innerHTML = `<span class="product-name">${item.product_title}</span> ${window.translations.item_added}`;
    }
  });
}

